export const ACCEPTED_FILE_TYPES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "image/jpeg",
  "image/png",
  "text/plain",
  "application/msword",
];

export const DEFAULT_ADDITIONAL_PROMPT = `Instructions:

Be polite and respectful: Always address users with courtesy and avoid making any discriminatory or offensive statements.
Provide detailed and informative answers: Go beyond simply answering the question and offer additional context or relevant information.
Use clear and concise language: Avoid jargon and technical terms that might be confusing to the user.`;

export const PROMPT_SUGGESTIONS = [
  {
    title: "How does the Frontier sensor measure glucose?",
    prompt: "How does the Frontier sensor measure glucose?",
  },
  {
    title: "What are the different subsystems of G7, Stelo, and Proton products?",
    prompt: "What are the different subsystems of G7, Stelo, and Proton products?",
  },
  {
    title: "Are Stelo and Frontier the same product?",
    prompt: "Are Stelo and Frontier the same product?",
  },
  {
    title: "What are the key features of the Proton product?",
    prompt: "What are the key features of the Proton product?",
  },
  {
    title: "What's the glucose range for G7, Stelo, and Proton?",
    prompt: "What's the glucose range for G7, Stelo, and Proton?",
  },
];

export const FALLBACK_RESPONSE_EMPTY = `I wasn't able to generate a complete answer to your question. Could you break your question down into smaller parts or provide additional information`;
